<script setup lang="ts">
import { ref, toRefs } from "vue";

const props = withDefaults(
  defineProps<{
    open: boolean;
    showSpinner: boolean;
    orderStatus: string;
  }>(),
  {
    open: false,
    showSpinner: false,
  },
);

const { open, showSpinner, orderStatus } = toRefs(props);

const emit = defineEmits<{
  (e: "onClose"): void;
  (e: "onConfirm", reason: string): void;
}>();

const cancellationReason = ref("");

const onClose = () => {
  cancellationReason.value = "";
  emit("onClose");
};
const onConfirm = () => {
  emit("onConfirm", cancellationReason.value);
  cancellationReason.value = "";
};
</script>

<template>
  <pn-modal
    @close="onClose"
    :open="open"
    label="Cancel Order"
    class="medium-modal"
  >
    <div :class="[{ spinner: showSpinner }]">
      <pn-spinner size="3" v-show="showSpinner" />
    </div>
    <div>
      <p class="pn-s">The order is currently {{ orderStatus }}.</p>
      <pn-textarea
        label="Cancellation Reason (Optional)"
        :value="cancellationReason"
        rows="3"
        cols="25"
        @change="
          (e: any) => (cancellationReason = e.target?.value ?? e.detail ?? '')
        "
      ></pn-textarea>
    </div>
    <div slot="buttons">
      <pn-button appearance="light" variant="outlined" @click="onClose"
        >No</pn-button
      >
      <pn-button appearance="danger" @click="onConfirm">Yes</pn-button>
    </div>
  </pn-modal>
</template>

<style lang="scss" scoped>
.medium-modal .pn-modal {
  max-width: 80% !important;
  width: 95% !important;
}
</style>
